export { default as Heading } from './components/heading'

// CODE_IMPROVEMENTS: If possible remove the original,
// THIS SHOULD NOT BE USED, IF IT IS USED, DELETE WHERE USED OR USE HEADING-UNDERLINE-2, Might also be fine to delete file that uses it as they could not be used also
export { default as HeadingUnderline } from './components/heading-underline'
export { default as HeadingUnderline2 } from './components/heading-underline-2'
